import { setJsonQuery } from 'shared/slices/jsonQuery';
import { TAsyncThunkAction } from 'shared/types/redux';
import { updateSearchMeta } from '../../searchMeta';
import { selectJsonQuery } from 'shared/selectors/jsonQuery';
import { removeUndergroundsFromJsonQuery } from 'shared/utils/jsonQuery';
import { IStationData } from 'shared/types/geo';

export const removeUndergroundStations =
  (stations: IStationData[]): TAsyncThunkAction =>
  async (dispatch, getState) => {
    const state = getState();
    const jsonQuery = selectJsonQuery(state);
    const nextJsonQuery = removeUndergroundsFromJsonQuery(jsonQuery, stations);

    dispatch(setJsonQuery(nextJsonQuery));
    dispatch(updateSearchMeta());
  };
